import { render, staticRenderFns } from "./AppealReview.vue?vue&type=template&id=636584de&scoped=true"
import script from "./AppealReview.vue?vue&type=script&lang=js"
export * from "./AppealReview.vue?vue&type=script&lang=js"
import style0 from "./AppealReview.vue?vue&type=style&index=0&id=636584de&prod&lang=scss&scoped=true"
import style1 from "./AppealReview.vue?vue&type=style&index=1&id=636584de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636584de",
  null
  
)

export default component.exports